import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import SelectEntityStatus from "~components/SelectEntityStatus/SelectEntityStatus.tsx";
import { TableFilter } from "~enums/tableFilter.ts";
import { EntityGroupTableFilterTypes } from "~pages/EntityGroups/EntityGroupListPage/enums/entityGroupTableFilterTypes.ts";

export const useGetEntityGroupTableFilters = (
  defaultFilter: Record<string, any> = {},
): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>(defaultFilter);
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);

  const filters: DataTableFilter[] = [
    {
      filterKey: EntityGroupTableFilterTypes.Status,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectEntityStatus
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.status.allOption",
          })}
        />
      ),
    },
  ];

  return {
    filters,
    currentFilter,
    handleFilterChange,
  };
};
